<div class="container m-b-20 layout-row align-end gap-20px">
  <button mat-raised-button color="primary" [routerLink]="['create']" *LOSxHasPermission="'CREATE_PAYMENTTYPE'">
    <fa-icon icon="plus" class="m-r-10"></fa-icon>
    {{ 'labels.buttons.Create Payment Type' | translate }}
  </button>
</div>

<div class="container">
  <div class="layout-row gap-20px">
    <mat-form-field class="flex-fill">
      <mat-label>{{ 'labels.inputs.Filter' | translate }}</mat-label>
      <input matInput (keyup)="applyFilter($event.target.value)" />
    </mat-form-field>
  </div>

  <div class="mat-elevation-z8 table-container">
    <table mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'labels.inputs.name' | translate }}</th>
        <td mat-cell *matCellDef="let paymentType">{{ paymentType.name }}</td>
      </ng-container>

      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'labels.inputs.Description' | translate }}</th>
        <td mat-cell *matCellDef="let paymentType">{{ paymentType.description }}</td>
      </ng-container>

      <ng-container matColumnDef="codeName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'labels.inputs.Code' | translate }}</th>
        <td mat-cell *matCellDef="let paymentType">{{ paymentType.codeName }}</td>
      </ng-container>

      <ng-container matColumnDef="isSystemDefined">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'labels.inputs.System Defined' | translate }}</th>
        <td mat-cell *matCellDef="let paymentType">
          <div [className]="paymentType.isSystemDefined === true ? 'true text-center' : 'false text-center'">
            @if (paymentType.isSystemDefined) {
              <fa-icon
                icon="check-circle"
                size="lg"
                matTooltip="{{ 'tooltips.Yes' | translate }}"
                matTooltipPosition="right"
              ></fa-icon>
            }
            @if (!paymentType.isSystemDefined) {
              <fa-icon
                icon="times-circle"
                size="lg"
                matTooltip="{{ 'tooltips.No' | translate }}"
                matTooltipPosition="right"
              ></fa-icon>
            }
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="isCashPayment">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'labels.inputs.Cash Payment' | translate }}</th>
        <td mat-cell *matCellDef="let paymentType">
          <div [className]="paymentType.isCashPayment === true ? 'true text-center' : 'false text-center'">
            @if (paymentType.isCashPayment) {
              <fa-icon
                icon="check-circle"
                size="lg"
                matTooltip="{{ 'tooltips.Yes' | translate }}"
                matTooltipPosition="right"
              ></fa-icon>
            }
            @if (!paymentType.isCashPayment) {
              <fa-icon
                icon="times-circle"
                size="lg"
                matTooltip="{{ 'tooltips.No' | translate }}"
                matTooltipPosition="right"
              ></fa-icon>
            }
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="position">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'labels.inputs.Position' | translate }}</th>
        <td mat-cell *matCellDef="let paymentType" class="text-center">{{ paymentType.position }}</td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Actions' | translate }}</th>
        <td mat-cell *matCellDef="let paymentType" class="layout-row">
          @if (!paymentType.isSystemDefined) {
            <button mat-button [routerLink]="[paymentType.id, 'edit']" color="primary" class="no-wrap">
              <fa-icon icon="edit" class="m-r-10"></fa-icon>{{ 'labels.buttons.Edit' | translate }}
            </button>
          }
          @if (!paymentType.isSystemDefined) {
            <button mat-button (click)="deletePaymentType(paymentType.id)" color="warn" class="no-wrap">
              <fa-icon icon="trash" class="m-r-10"></fa-icon>{{ 'labels.buttons.Delete' | translate }}
            </button>
          }
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons></mat-paginator>
  </div>
</div>
